import { humanFilesize, nearestMB, extractExtension } from '@/utils/files';

export function logAmplitudeEvent(eventName, eventContext = null) {
  if (!eventName) {
    throw Error('No event name given');
  }

  if (!window.amplitude) {
    return;
  }

  window.amplitude.getInstance().logEvent(eventName, eventContext);
}

export function logFileSizeForAmplitude(file) {
    if (!(file instanceof File)) {
      return;
    }

    if (file.size <= 0) {
        return;
    }

    /**
     * TODO: see if we can merge the two calls into one - need
     * to ensure that the properties are filterable separately
     * in amplitude (that is, that they aren't dependent on
     * each other)
     */
    logAmplitudeEvent('uploaded-filesize-range', {
        size: nearestMB(file.size),
    });
    logAmplitudeEvent('uploaded-filesize-human', {
        size: humanFilesize(file.size),
    });
}

export function logFileTypeForAmplitude(file) {
    if (!(file instanceof File)) {
      return;
    }

    const extension = extractExtension(file.name) || 'unknown';

    logAmplitudeEvent('uploaded-filetype', {
        type: extension.toLowerCase(),
    });
}

export default {
    logAmplitudeEvent,
    logFileSizeForAmplitude,
    logFileTypeForAmplitude,
};
